import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RfiRelatedItemsComponent } from '../create-rfi/rfi-related-items/rfi-related-items.component';
import { MatIconModule } from '@angular/material/icon';
import { ClarificationDesignComponent } from "../create-rfi/clarification-design/clarification-design.component";
import { RfiEmailsComponent } from "../create-rfi/rfi-emails/rfi-emails.component";
import { RfiChangeHistoryComponent } from "../create-rfi/rfi-change-history/rfi-change-history.component";

@Component({
  selector: 'app-rfi-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    RfiRelatedItemsComponent,
    MatIconModule,
    ClarificationDesignComponent,
    RfiEmailsComponent,
    RfiChangeHistoryComponent
],
  templateUrl: './rfi-wrapper.component.html',
  styleUrl: './rfi-wrapper.component.css',
})
export class RfiWrapperComponent {
  activeTab: string = 'General'; // Default active tab
  constructor(public router: Router) {}

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
}
